document.querySelectorAll('.nexgi-seo-content-read-more').forEach(function(wrapper) {
    var content = wrapper.querySelector('.m-richtext__description');
    if (!content) return;

    var fullHTML = content.innerHTML;

    var plainText = fullHTML
        .replace(/<\/(h1|h2|h3|h4|h5|h6|p|div|li)>/gi, ' ')
        .replace(/<[^>]+>/g, '')
        .replace(/\s+/g, ' ')
        .trim();

    if (plainText.length <= 150) return;

    var fontSize = parseFloat(window.getComputedStyle(content).fontSize);
    var avgCharWidth = fontSize * 0.6;
    var charsPerLine = Math.floor(content.offsetWidth / avgCharWidth);
    var maxChars = Math.floor(charsPerLine * 4);

    var shortText = plainText.substring(0, maxChars) + '...';

    content.innerHTML = '<span style="margin-right:6px">' + shortText + '</span><a href="#" class="nexgi-read-more-btn">Read More</a>';

    wrapper.addEventListener('click', function(e) {
        if (!e.target.classList.contains('nexgi-read-more-btn')) return;
        e.preventDefault();

        if (e.target.textContent === 'Read More') {
            content.innerHTML = fullHTML + '<a href="#" class="nexgi-read-more-btn">Read Less</a>';
        } else {
            content.innerHTML = '<span style="margin-right:6px">' + shortText + '</span><a href="#" class="nexgi-read-more-btn">Read More</a>';
            wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    });
});


// js to hidded topbar when click on cross
(function () {
  var topbar = document.querySelector('.m-topbar');
  var closeBtn = document.querySelector('.nx-close-topbar');

  if (!topbar || !closeBtn) return;

  var STORAGE_KEY = 'topbarClosedTime';
  var EXPIRY_TIME = 24 * 60 * 60 * 1000; // 24 hours

  function closeTopbar() {
    topbar.classList.add('nx-closed-topbar');
    localStorage.setItem(STORAGE_KEY, Date.now());
  }

  function checkTopbarState() {
    var savedTime = localStorage.getItem(STORAGE_KEY);

    if (!savedTime) return;

    var now = Date.now();
    var diff = now - parseInt(savedTime, 10);

    if (diff < EXPIRY_TIME) {
      topbar.classList.add('nx-closed-topbar');
    } else {
      topbar.classList.remove('nx-closed-topbar');
      localStorage.removeItem(STORAGE_KEY);
    }
  }

  // Event
  closeBtn.addEventListener('click', closeTopbar);

  // Init check on load
  checkTopbarState();
})();

// js to change plcaeholder content for search in header
(function () {

  var texts = [
    "Search Rings",
    "Search Rani Haar",
    "Search Choker",
    "Search Necklace",
    "Search Pendant"
  ];

  document.querySelectorAll('.m-search-form__label').forEach(function(container) {

    var index = 0;

    var current = document.createElement('span');
    current.textContent = texts[index];

    container.innerHTML = '';
    container.appendChild(current);

    function changeText() {
      var nextIndex = (index + 1) % texts.length;

      var next = document.createElement('span');
      next.textContent = texts[nextIndex];
      next.classList.add('enter');

      container.appendChild(next);

      next.offsetHeight;

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          current.classList.add('exit-active');
          next.classList.add('enter-active');
        });
      });

      setTimeout(function () {
        if (current.parentNode) {
          container.removeChild(current);
        }

        current = next;
        index = nextIndex;

      }, 400);
    }

    setInterval(changeText, 3000);

  });

})();


/**
 * Hide only empty product blocks individually
 * Rating and badge work independently
 */
(function () {

  function cleanProductBlocks() {

    // Rating block check
    document.querySelectorAll('.main-product__block-rating').forEach(el => {
      const scoreEl = el.querySelector('[data-score]');
      const starsEl = el.querySelector('.jdgm-prev-badge__stars');

      const hasValidRating =
        scoreEl &&
        starsEl &&
        scoreEl.getAttribute('aria-label') !== '0.00 stars';

      if (!hasValidRating) {
        el.style.display = 'none';
      } else {
        el.style.display = '';
      }
    });

    // Badge block check
    document.querySelectorAll('.main-product__block-badge').forEach(el => {
      const hasContent = el.innerHTML.trim().length > 0;

      if (!hasContent) {
        el.style.display = 'none';
      } else {
        el.style.display = '';
      }
    });

  }

  window.addEventListener('load', cleanProductBlocks);

  const observer = new MutationObserver(cleanProductBlocks);
  observer.observe(document.body, { childList: true, subtree: true });

})();


// Funcrion to call on custom checkout button
function triggerShopifyCheckout(el) {
  var wrapper = el.closest('.nx-checkout-click');
  var realBtn = wrapper.querySelector(
    '.shopify-hidden-btn button, .shopify-hidden-btn [role="button"]'
  );
  if (realBtn) {
    realBtn.click();
  }
}